import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Parameters from "china_pcb/pcb_fabrication/components/Parameters";
import Loading from "china_pcb/pcb_fabrication/components/Loading";
import SupplierInfos from "china_pcb/pcb_fabrication/components/price/SupplierInfos";
import PriceMatrices from "china_pcb/pcb_fabrication/components/price/PriceMatrices";
import EmailQuote from "pu-react/components/EmailQuote";
import { doEmailQuote } from "china_pcb/pcb_fabrication/fabricationSlice";

const Fabrication = () => {
  const dispatch = useDispatch();

  const { quoteStep, parameters, parametersChanged } = useSelector(
    (state) => state.fabrication
  );

  const onSendEmailQuote = (data, token) =>
    dispatch(doEmailQuote({ data, token }));

  return (
    <>
      <Loading />
      <div className="row">
        <div className="col-lg-4">
          <div className="parameters">
            <Parameters />
          </div>
        </div>
        <div className="col-lg-8">
          <h2 className="offshore-pcb-title">
            Get an instant quote from our network of PCB partners in China.
          </h2>
          <div className="pcb-price-section">
            <div className="text-end p-3 pb-0 bg-white">
              <EmailQuote
                quoteStep={quoteStep}
                parametersChanged={parametersChanged}
                parameters={parameters}
                onSendEmailQuote={onSendEmailQuote}
              />
            </div>
            <SupplierInfos />
            <PriceMatrices />
          </div>
        </div>
      </div>
    </>
  );
};

export default Fabrication;
